export const types = {
  SSO_ERROR: 'auth/sso/SSO_ERROR',

  SSO_DISCOVER_CLEAR: 'auth/sso/SSO_DISCOVER_CLEAR',
  SSO_DISCOVER_ERROR: 'auth/sso/SSO_DISCOVER_ERROR',
  SSO_DISCOVER_REQUEST: 'auth/sso/SSO_DISCOVER_REQUEST',
};

export const sso = {
  error: (error) => ({
    type: types.SSO_ERROR,
    payload: error,
  }),
};

export const discover = {
  clear: () => ({
    type: types.SSO_DISCOVER_CLEAR,
  }),
  error: (error) => ({
    type: types.SSO_DISCOVER_ERROR,
    payload: error,
  }),
  request: (email) => ({
    type: types.SSO_DISCOVER_REQUEST,
    payload: { email },
  }),
};
